import { payeeLabel } from './format';

// จัดกลุ่มแถวตามเลขบัญชี (payee.account_number) — รายการที่ไม่มีเลขบัญชี (เช่น เบิกที่ยังไม่กรอกบัญชี)
// รวมอยู่กลุ่ม "ไม่มีเลขบัญชี" ด้วยกันหมด เลขลำดับ (คอลัมน์แรก) นับใหม่ตามลำดับที่แสดงจริงบนจอ (กลุ่มต่อกลุ่ม
// ไล่ทีละแถวในกลุ่มนั้น) ไม่ใช่ตำแหน่งเดิมก่อนจัดกลุ่ม — ไม่งั้นตัวเลขจะกระโดดไปมาไม่เรียงกันเวลาดูจริง
// (เช่น กลุ่มแรกโชว์ 1,2,3 กลุ่มถัดไปโชว์ 8,15,22 แทนที่จะต่อเนื่อง 4,5,6)
// ลำดับกลุ่ม = ลำดับที่เจอรายการแรกของบัญชีนั้น, ภายในกลุ่มคงลำดับเดิมของ rows (เรียงตาม "เรียงตาม" ของ
// Finance มาแล้วใน useQueueTabs.js) — เดิมดันรายการที่ยังไม่ตัดสินใจขึ้นก่อนในแต่ละกลุ่ม เลิกแล้วตามที่ผู้ใช้ขอ
// ให้ลำดับตรงกับ /finance/expenses
export function groupRowsByAccount(rows) {
  const groups = new Map();
  rows.forEach((row) => {
    const key = (row?.payee?.account_number || '').trim() || 'ไม่มีเลขบัญชี';
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        accountNumber: row?.payee?.account_number || '',
        bank: row?.payee?.bank || '',
        payeeName: payeeLabel(row),
        totalAmount: 0,
        items: [],
      });
    }
    const group = groups.get(key);
    group.items.push({ row });
    group.totalAmount += Number(row.net_price) || Number(row.price) || 0;
  });

  const groupList = Array.from(groups.values());

  let displayIndex = 0;
  groupList.forEach((group) => {
    group.items.forEach((item) => {
      item.index = displayIndex;
      displayIndex += 1;
    });
  });

  return groupList;
}

// รายการที่จ่ายจริงสำเร็จแล้ว (status SUCCESS — โผล่ได้เฉพาะแท็บ "วันนี้"/"ประวัติ" ที่ไม่กรอง statuses)
// ไม่มีอะไรให้ตัดสินใจอีกแล้ว ซ่อน checkbox เลือก + ปุ่มอนุมัติ/ปฏิเสธ/รอก่อนทิ้งไปเลย กันกดซ้ำ/เลือกไปทำ
// bulk action โดยไม่ตั้งใจ
export function isRowFinalized(row) {
  return row?.status === 'SUCCESS';
}

// แถวที่มี checkbox ให้ติ๊กจริง (ตรงกับที่ ExpenseRow.js render checkbox) — ไม่ใช่แค่ !isRowFinalized
// เฉยๆ เพราะแถวที่ตัดสินใจไปแล้ว (flag หลักของหน้า = mode.statusField ไม่ใช่ PENDING) ก็ซ่อน checkbox
// ไปด้วยเหมือนกัน (เหลือแค่ปุ่ม "ยกเลิก" ทีละแถว ไม่รองรับ bulk action) — ใช้ฟังก์ชันนี้เป็นแหล่งความจริง
// เดียวกันทั้ง "เลือกทั้งหมด" (useRowSelection.js) และ checkbox รายแถว (ExpenseRow.js) กันไม่ให้ "เลือก
// ทั้งหมด" ไปเลือกแถวที่ไม่มี checkbox โชว์อยู่จริงบนจอ
export function isRowSelectable(row, statusField) {
  return !isRowFinalized(row) && (row?.[statusField] || 'PENDING') === 'PENDING';
}
